export const UPDATE_FORM_VALUES = '@@form/UPDATE_FORM_VALUES'
export const UPDATE_FORM_SUCCESS = '@@form/UPDATE_FORM_SUCCESS'
export const RESET_FORM = '@@form/RESET_FORM'
export const RESET_FORM_SUCCESS = '@@form/RESET_FORM_SUCCESS'
export const SUBMIT_FORM_SUCCESS = '@@form/SUBMIT_FORM_SUCCESS'
export const SET_FIELD_VALUE = '@@form/SET_FIELD_VALUE'
export const SET_FIELD_VALUE_SUCCESS = '@@form/SET_FIELD_VALUE_SUCCESS'
export const GET_FORM_VALUES = '@@form/GET_FORM_VALUES'
export const GET_FORM_VALUES_SUCCESS = '@@form/GET_FORM_VALUES_SUCCESS'
export const ADD_DYNAMIC_FORM = '@@form/ADD_DYNAMIC_FORM'
export const DELETE_DYNAMIC_FORM = '@@form/DELETE_DYNAMIC_FORM'

/**
 * Update the form with completely new values.
 * @param form Name of the form to update
 * @param values New values for the form
 */
export const updateFormValues = (form, values) => ({
  type: UPDATE_FORM_VALUES,
  form,
  values
})

/**
 * Dispatched after a successful updateFormValues call
 */
export const updateFormSuccess = (form) => ({
  type: UPDATE_FORM_SUCCESS,
  form
})

/**
 * Reset the entire form with default values
 * @param form Name of the form
 */
export const resetForm = (form) => ({
  type: RESET_FORM,
  form
})

/**
 * Dispatched after a successful resetForm call
 */
export const resetFormSuccess = (form) => ({
  type: RESET_FORM_SUCCESS,
  form
})

/**
 * Dispatched after a successful submission of the form
 */
export const submitFormSuccess = (form, values) => ({
  type: SUBMIT_FORM_SUCCESS,
  form,
  values
})

/**
 * Set the value of a field in a form.
 * @param form Name of the form
 * @param field An object or an array of objects of shape { field, value }
 */
export const setFieldValue = (form, field) => ({
  type: SET_FIELD_VALUE,
  form,
  field
})

/**
 * Dispatched after a successful setFieldValue call
 */
export const setFieldValueSuccess = (form, field) => ({
  type: SET_FIELD_VALUE_SUCCESS,
  form,
  field
})

export const getFormValues = (form) => ({
  type: GET_FORM_VALUES,
  form
})

export const getFormValuesSuccess = (form, values) => ({
  type: GET_FORM_VALUES_SUCCESS,
  form,
  values
})

/**
 * Adds a new form to the redux store to enable actions for the form.
 */
export const addDynamicForm = (name) => ({
  type: ADD_DYNAMIC_FORM,
  name
})

/**
 * Removes a form from the redux store.
 */
export const deleteDynamicForm = (name) => ({
  type: DELETE_DYNAMIC_FORM,
  name
})
